/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

import React from 'react';
import PropTypes from 'prop-types';

import Avatar from 'src/components/CE/Avatar';
import Categories from 'src/components/Common/Categories';
import CommonHeadline from 'src/components/Common/Headline';
import Date from 'src/components/CE/Date';
import Disqus from 'src/components/CE/Disqus';
import Headline from 'src/components/CE/Headline';

import { container } from './mdxBlogPost.module.css';

// TODO: check if it works, when tailwind css is imported directly here
// import 'src/styles/global.css';
import './prism.css';

import dummyImage from '../img/blog/dummy.jpg';

const MdxBlogPostTemplate = ({ children, location, pageContext }) => {
  const { author, categories, disqusIdentifier, disqusUrl, featureImg, title } =
    pageContext.frontmatter;
  const path = location.pathname;
  const publishingDate = path.match(/^\/blog\/([0-9]+-[0-9]+-[0-9]+).*/)[1];

  let featureImgSrc = null;
  if (!featureImg) {
    featureImgSrc = dummyImage;
  } else if (featureImg.startsWith('http')) {
    featureImgSrc = featureImg;
  } else {
    featureImgSrc = require(`../img${path}${featureImg}`).default;
  }

  return (
    <>
      <header
        className="blog-header"
        style={{
          backgroundImage: `url('${featureImgSrc}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
      >
        <Headline size={1}>
          {title || 'TODO: Bitte Titel angeben'}
          <br />
          <small>
            <Date date={publishingDate} />
            {' von '}
            <Avatar name={author || 'fuf'} withName />
          </small>
        </Headline>
        <Categories categories={categories} />
      </header>
      <div className={`markdown container	${container}`}>{children}</div>
      <Disqus
        identifier={disqusIdentifier}
        shortname="froehlichundfrei"
        url={location.href}
        urlLegacy={disqusUrl}
      >
        <CommonHeadline size={3}>Kommentare</CommonHeadline>
      </Disqus>
    </>
  );
};

MdxBlogPostTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  pageContext: PropTypes.instanceOf(Object).isRequired,
};

export default MdxBlogPostTemplate;
